import axios from "axios";

const editarProductoServicio = async (data, id) => {
    const token = localStorage.getItem("token");
    const config = {
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `${token}`,
        },
    };

    try {
        const response = await axios.put(
            `${process.env.REACT_APP_API_URL}/productos/editar/${id}`,
            data,
            config
        );
        return [true, response.data];
    } catch (error) {
        return [false, error.status, error.response.data];
    }
}

export {
    editarProductoServicio
}